(function () {
  // The tile follows the cart gift with purchase (Alpine.store('gwp'), assets/gift-with-purchase.js):
  // it shows only while that is running (on, inside its start/end dates, with at least one gift tier),
  // and [amount] in the tile text becomes the matching tier's spend in the shopper's currency.
  // Gift 1 pairs with the lowest spend tier, gift 2 with the next. A sold-out gift drops out of the
  // tile; if every gift is sold out the tile hides.
  var INTERVAL = 3500;
  var WAIT_FOR_STORE = 5000;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fill(template, amount) {
    return (template || '').replace(/\[amount\]/g, amount);
  }

  function onGwpStore(callback) {
    var done = false;
    function tryNow() {
      if (done) return true;
      var store = window.Alpine && window.Alpine.store && window.Alpine.store('gwp');
      if (!store) return false;
      done = true;
      callback(store);
      return true;
    }
    if (tryNow()) return;
    document.addEventListener('alpine:initialized', tryNow);
    setTimeout(function () {
      if (!tryNow()) callback(null);
    }, WAIT_FOR_STORE);
  }

  function init(root) {
    if (root.dataset.gwpTileReady) return;
    root.dataset.gwpTileReady = '1';

    var allSlides = Array.prototype.slice.call(root.querySelectorAll('.gwp-tile__slide'));
    var allDots = Array.prototype.slice.call(root.querySelectorAll('.gwp-tile__dot'));
    var dotsWrap = root.querySelector('.gwp-tile__dots');
    var fadeEls = root.querySelectorAll('[data-gwp-tile-fade]');
    var fields = {
      name: root.querySelector('[data-gwp-tile-name]'),
      line: root.querySelector('[data-gwp-tile-line]'),
      value: root.querySelector('[data-gwp-tile-value]'),
      condition: root.querySelector('[data-gwp-tile-condition]'),
    };
    var slides = [];
    var current = -1;
    var paused = false;
    var timer = null;

    function writeFields(slide) {
      var data = slide.dataset;
      Object.keys(fields).forEach(function (key) {
        if (fields[key] && data[key] != null) fields[key].textContent = data[key];
      });
    }

    function show(index, instant) {
      if (index === current || !slides[index]) return;
      current = index;
      allSlides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide === slides[index]);
      });
      allDots.forEach(function (dot) {
        dot.setAttribute('aria-current', dot.dataset.slide === slides[index].dataset.slide ? 'true' : 'false');
      });
      if (instant || reduceMotion) {
        writeFields(slides[index]);
        return;
      }
      fadeEls.forEach(function (el) {
        el.classList.add('is-fading');
      });
      setTimeout(function () {
        writeFields(slides[current]);
        fadeEls.forEach(function (el) {
          el.classList.remove('is-fading');
        });
      }, 450);
    }

    function apply(store) {
      var running = store && store.active && store.tiers && store.tiers.length;
      var tiers;
      if (running) {
        tiers = store.tiers.slice().sort(function (a, b) {
          return a.min - b.min;
        });
      } else if (window.Shopify && window.Shopify.designMode) {
        // Keep the tile visible in the theme editor so it can be styled before the gift tiers are set
        tiers = allSlides.map(function () {
          return { min: null };
        });
      } else {
        root.classList.add('gwp-tile--off');
        root.classList.remove('gwp-tile--pending');
        return;
      }
      var money = function (min) {
        return min === null ? '$—' : store.money(min);
      };
      var activeSlide = slides[current];
      slides = [];
      allSlides.forEach(function (slide, i) {
        var tier = tiers[i];
        // No matching tier, or that gift has sold out: drop it from the tile
        if (!tier || tier.soldOut) {
          slide.dataset.off = '1';
          return;
        }
        delete slide.dataset.off;
        var amount = money(tier.min);
        slide.dataset.line = fill(slide.dataset.lineTemplate, amount);
        slide.dataset.condition = fill(slide.dataset.conditionTemplate, amount);
        slides.push(slide);
      });
      if (!slides.length) {
        root.classList.add('gwp-tile--off');
        root.classList.remove('gwp-tile--pending');
        return;
      }
      allDots.forEach(function (dot) {
        dot.hidden = !!allSlides[+dot.dataset.slide].dataset.off;
      });
      if (dotsWrap) dotsWrap.hidden = slides.length < 2;

      var keep = slides.indexOf(activeSlide);
      current = -1;
      show(keep > -1 ? keep : 0, true);
      root.classList.remove('gwp-tile--pending', 'gwp-tile--off');
    }

    allDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = slides.indexOf(allSlides[+dot.dataset.slide]);
        if (index > -1) show(index);
      });
    });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    onGwpStore(function (store) {
      if (!store) return apply(null);
      // Re-run whenever the gift with purchase updates (cart changes, start/end time passing)
      window.Alpine.effect(function () {
        var active = store.active;
        var tiers = store.tiers;
        setTimeout(function () {
          apply({ active: active, tiers: window.Alpine.raw(tiers), money: store.money.bind(store) });
        });
      });
    });

    if (reduceMotion) return;
    timer = setInterval(function () {
      if (!root.isConnected) {
        clearInterval(timer);
        return;
      }
      // Skip while hidden: the other breakpoint's copy, a switched-off tile, or a background tab
      if (paused || document.hidden || root.offsetParent === null || slides.length < 2) return;
      show((current + 1) % slides.length);
    }, INTERVAL);
  }

  function scan() {
    document.querySelectorAll('[data-gwp-tile]').forEach(init);
  }

  scan();
  // Filters and sorting replace the grid, so set up any new tiles
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
